import BaseElement from './BaseElement';
import InlineCountdown from '../Components/InlineCountdown';
class CountdownTimer extends BaseElement {
    constructor() {
        super(...arguments);
        this.element = InlineCountdown;
    }
}
export default CountdownTimer;
